import { Api } from '../../common/api/const';
import ClientDTO from '../model/dto-get/clientDTO';

export class ClientsApiService {
    static fetchClients = () => Api().get(`/clients`);
    static postClient = (clientDTO: ClientDTO) => Api().post(`/clients`, clientDTO);
    static putClient = (clientDTO: ClientDTO) => Api().put(`/clients/${clientDTO.id}`, clientDTO);
    static replace = (o: string, n: string) => Api().post(`/clients/${o}/to/${n}`)
}